import React, { useState } from 'react'
import { TextField, Toolbar, Typography, Button, Grid } from '@mui/material';
import AddUpdateUnitDialog from 'app/components/Dialog/AddUpdateUnitDialog';
import { useSelector } from 'react-redux';
import { isRoleCheckList } from 'app/utils/appHelpers';
import AddIcon from '@mui/icons-material/Add';
import AddUpdateAnnouncementDialog from '../../Dialog/AddUpdateAnnouncementDialog';

function AnnouncementDataTableToolbar({ pageTitle, data2, setData, afterUpdateFunc, addAfterTable, type }) {


    const fontSettings = useSelector((state) => state.meeting.fontSettings);
    const { baseFontSize } = fontSettings;
    const { authUser } = useSelector(state => state.auth);

    const [searchText, setSearchText] = useState("");
    const [addUnitDialogStatus, setAddUnitDialogStatus] = useState(false);
    const [addDialogStatus, setAddDialogStatus] = useState(false);

    const handleChangeSearchText = (text) => {
        if (text !== "") {
            const filterData = data2.filter(
                (item) =>
                    item.inst.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.name.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.id === Number(text)
            );

            setSearchText(text);
            setData(filterData);
        } else {
            setSearchText(text);
            setData(data2);
        }
    };

    const handleSearch = (event) => {
        const searchValue = event.target.value;
        setSearchText(searchValue);

        if (searchValue === '') {
            setData([...data2]);
        } else {
            const filteredData = data2.filter(item =>
                item.title.toLowerCase().includes(searchValue.toLowerCase()) ||
                item.body.toLowerCase().includes(searchValue.toLowerCase())
            );
            setData(filteredData);
        }
    };


    return (
        <Grid container spacing={2} alignItems="center" sx={{ p: 2 }}>
            <Grid item xs={12} md={6}>
                <h4>{pageTitle}</h4>
            </Grid>

            {
                isRoleCheckList(authUser.userRoles, [1, 373, 370, 369]) && (
                    <Grid item xs={12} md={2}>
                        <Button
                            variant="contained"
                            onClick={() => setAddDialogStatus(true)}
                            fullWidth
                        >
                            Duyuru Ekle
                        </Button>
                    </Grid>
                )
            }

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Duyuru ara..."
                    value={searchText}
                    onChange={handleSearch}
                />
            </Grid>





            <AddUpdateAnnouncementDialog
                open={addDialogStatus}
                onClose={() => setAddDialogStatus(false)}
                afterUpdateFunc={afterUpdateFunc}
                addAfterTable={addAfterTable}
            />
        </Grid>
    );
};

export default AnnouncementDataTableToolbar